import { type PropsWithChildren } from 'react';

import { iconShape } from './IconShape.sty.js';

/** @internal */
export interface IconShapeProps {
  active?: boolean;
  color?: string;
}

/** @internal */
export const IconShape = ({
  active,
  color = 'inherit',
  children,
}: PropsWithChildren<IconShapeProps>) => {
  return (
    <div className={iconShape({ active })} style={{ color }}>
      {children}
    </div>
  );
};

IconShape['displayName'] = 'IconShape';
